export class ServerRandomUtils {
	// return random in [min, max]
	public static randomInt(min: number, max: number): number {
		return Math.floor(Math.random() * (max - min + 1)) + min;
	}

	public static randomValueWithWeights<T>(values: T[], weights: number[]): T {
		if (values.length !== weights.length) {
			throw new Error('ServerRandomUtils::randomValueWithWeights number of values should be the same as number of weights');
		}
		if (!ServerRandomUtils.checkAllPositiveNoZeros(weights)) {
			throw new Error('ServerRandomUtils::randomValueWithWeights weights values must be >= 0');
		}
		if (!ServerRandomUtils.checkAllIntegers(weights)) {
			throw new Error('ServerRandomUtils::randomValueWithWeights weights values must be all integers');
		}

		const totalWeights: number = ServerRandomUtils.sumOf(weights);
		const randomValue: number = ServerRandomUtils.randomInt(0, totalWeights - 1);

		let current: number = 0;
		let index: number = 0;
		for (const num of weights) {
			current += num;
			if (randomValue < current) {
				return values[index];
			}
			index++;
		}

		// shouldn't happen.
		return null;

	}

	public static randomIntValueWithExceptions(min: number, max: number, exceptions: number[]): number {
		if (max - min < exceptions.length) {
			throw new Error('ServerRandomUtils::randomIntValueWithExceptions too many exceptions or somthing wrong with numbers');
		}

		while (true) {
			const genNumber: number = ServerRandomUtils.randomInt(min, max);
			if (exceptions.indexOf(genNumber) === -1) {
				return genNumber;
			}
		}
	}

	protected static sumOf(numsArr: number[]): number {
		let total: number = 0;
		for (const num of numsArr) {
			total += num;
		}

		return total;
	}

	protected static checkAllPositiveNoZeros(numsArr: number[]): boolean {
		for (const num of numsArr) {
			if (num <= 0) {
				return false;
			}
		}

		return true;
	}

	protected static checkAllIntegers(numsArr: number[]): boolean {
		for (const num of numsArr) {
			if (!Number.isInteger(num)) {
				return false;
			}
		}

		return true;
	}
}


// WEBPACK FOOTER //
// ./@fantasmagames/prototype/src/utils/ServerRandomUtils.ts